var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('@/assets/images/fitting-icon.png'),"draggable":"false","alt":"","width":"201","height":"201"}})}
var staticRenderFns = []

export { render, staticRenderFns }